<template>
  <div v-if="type === 'loader'" class="card">
    <div class="card__image"></div>
    <div class="card__body">
      <h3 class="card__title loading">New Information on Lassa Fever</h3>
      <p
        class="loading"
      >Lassa fever, also known as Lassa hemorrhagic fever (LHF), with the common symptoms of Fever…</p>
      <div class="card__meta d-flex align-items-center loading">
        <span>by John Doe, 6 hours ago</span>
      </div>
    </div>
  </div>
  <div v-else class="card">
    <template>
      <div class="card__body">
        <h5 class="card__title">
          <div class="d-flex flex-row justify-content-between text-muted font-weight-light">
            <span>{{tracker.circle.title}}</span>
            <!--span>{{tracker.member_count.happrox}}</span-->
          </div>
        </h5>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "CallCard",
  props: ["type", "tracker"],
  computed: {
    // truncatedBody: function() {
    //   return `${this.tracker.first_media.body
    //     .split("")
    //     .splice(0, 100)
    //     .join("")}...`;
    // }
  },
  methods: {
    has(obj, path) {
      if (typeof path !== "string") {
        return false;
      }
      if (typeof obj !== "object") {
        return false
      }

      var path_array = path.split(".");
      if (obj.hasOwnProperty(path_array[0])) {
        if (path_array.length > 1) {
          var newPath = path_array
            .slice(1)
            .join(".")
            .toString();
          return has(obj[path_array[0]], newPath);
        }
        return obj.hasOwnProperty(path_array[0]);
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  background: whitesmoke !important;
  color: transparent !important;
}
.card {
  background: #fff;
  margin-bottom: 30px;
  &__image {
    background: #14264d;
    border-radius: 6px 6px 0 0;
    height: 180px;
    background-size: cover;
    background-position: center center;
    overflow: hidden;
    display: none;
  }
  &__body {
    padding: 20px;
  }
  &__title {
    font-size: 20px;
  }
  &__meta {
    color: #919eab;
    font-size: 13px;
  }
}
</style>